/**
 * Dolfi Exit Intent Popup Script
 * File: assets/dolfi-exit-intent.js
 * Multilingual support: IT, EN, ES, DE, FR
 */

// Multilingual translations
const DOLFI_TRANSLATIONS = {
  it: {
    stepCounter: 'Passo __NUM__ di 3',
    title1: 'Aspetta un momento!',
    intro1: 'La tua opinione è preziosa per migliorare l\'esperienza nel nostro atelier digitale.',
    question1: 'Cosa ti ha fermato dall\'acquistare oggi?',
    multipleAnswers: '(puoi selezionare più opzioni)',
    reason1: 'Prezzo troppo alto per il mio budget',
    reason2: 'Spedizione costosa (sotto 79€)',
    reason3: 'Tempi di consegna troppo lunghi',
    reason4: 'Sito dispersivo - non trovo quello che cerco',
    reason5: 'Incertezza sulle dimensioni reali',
    reason6: 'Altro motivo',
    reasonOtherPlaceholder: 'Puoi specificare il motivo...',
    btnContinue: 'Continua',
    title2: 'Cosa ti aiuterebbe a completare l\'acquisto oggi?',
    intro2: 'Il tuo feedback ci aiuta a migliorare l\'esperienza di chi cerca l\'autenticità dell\'artigianato italiano.',
    suggestionPlaceholder: 'Condividi con noi cosa renderebbe più semplice il tuo acquisto...',
    btnBack: 'Indietro',
    title3: 'Un ultimo passo!',
    emailIntro: 'Lasciaci la tua email per ricevere soluzioni personalizzate alle tue esigenze e offerte esclusive sui nostri capolavori artigianali.',
    emailPlaceholder: 'La tua email',
    emailNote: 'Analizzeremo attentamente le tue risposte per offrirti la migliore esperienza d\'acquisto e trovare la soluzione più adatta per te.',
    btnSubmit: 'Invia feedback',
    successTitle: 'Grazie del tuo prezioso feedback!',
    successMessage: 'Abbiamo ricevuto le tue risposte e le analizzeremo con cura per migliorare la nostra esperienza d\'acquisto e rispondere meglio alle tue esigenze. L\'artigianato italiano si evolve anche grazie al tuo contributo.'
  },
  en: {
    stepCounter: 'Step __NUM__ of 3',
    title1: 'Wait a moment!',
    intro1: 'Your opinion is valuable to improve the experience in our digital atelier.',
    question1: 'What stopped you from buying today?',
    multipleAnswers: '(multiple answers possible)',
    reason1: 'Price too high for my budget',
    reason2: 'Expensive shipping (under 79€)',
    reason3: 'Delivery times too long',
    reason4: 'Confusing website - can\'t find what I\'m looking for',
    reason5: 'Uncertainty about real dimensions',
    reason6: 'Other reason',
    reasonOtherPlaceholder: 'You can specify the reason...',
    btnContinue: 'Continue',
    title2: 'What would help you complete your purchase today?',
    intro2: 'Your feedback helps us improve the experience for those seeking authentic Italian craftsmanship.',
    suggestionPlaceholder: 'Share with us what would make your purchase easier...',
    btnBack: 'Back',
    title3: 'One last step!',
    emailIntro: 'Leave us your email to receive personalized solutions to your needs and exclusive offers on our artisan masterpieces.',
    emailPlaceholder: 'Your email',
    emailNote: 'We will carefully analyze your responses to offer you the best shopping experience and find the most suitable solution for you.',
    btnSubmit: 'Send feedback',
    successTitle: 'Thank you for your valuable feedback!',
    successMessage: 'We have received your responses and will analyze them carefully to improve our shopping experience and better respond to your needs. Italian craftsmanship evolves thanks to your contribution too.'
  },
  es: {
    stepCounter: 'Paso __NUM__ de 3',
    title1: '¡Espera un momento!',
    intro1: 'Tu opinión es valiosa para mejorar la experiencia en nuestro taller digital.',
    question1: '¿Qué te impidió comprar hoy?',
    multipleAnswers: '(múltiples respuestas posibles)',
    reason1: 'Precio demasiado alto para mi presupuesto',
    reason2: 'Envío costoso (menos de 79€)',
    reason3: 'Tiempos de entrega demasiado largos',
    reason4: 'Sitio confuso - no encuentro lo que busco',
    reason5: 'Incertidumbre sobre las dimensiones reales',
    reason6: 'Otro motivo',
    reasonOtherPlaceholder: 'Puedes especificar el motivo...',
    btnContinue: 'Continuar',
    title2: '¿Qué te ayudaría a completar tu compra hoy?',
    intro2: 'Tu feedback nos ayuda a mejorar la experiencia de quienes buscan la autenticidad de la artesanía italiana.',
    suggestionPlaceholder: 'Comparte con nosotros qué haría más fácil tu compra...',
    btnBack: 'Atrás',
    title3: '¡Un último paso!',
    emailIntro: 'Déjanos tu email para recibir soluciones personalizadas a tus necesidades y ofertas exclusivas en nuestras obras maestras artesanales.',
    emailPlaceholder: 'Tu email',
    emailNote: 'Analizaremos cuidadosamente tus respuestas para ofrecerte la mejor experiencia de compra y encontrar la solución más adecuada para ti.',
    btnSubmit: 'Enviar comentarios',
    successTitle: '¡Gracias por tus valiosos comentarios!',
    successMessage: 'Hemos recibido tus respuestas y las analizaremos cuidadosamente para mejorar nuestra experiencia de compra y responder mejor a tus necesidades. La artesanía italiana también evoluciona gracias a tu contribución.'
  },
  de: {
    stepCounter: 'Schritt __NUM__ von 3',
    title1: 'Einen Moment bitte!',
    intro1: 'Deine Meinung ist wertvoll, um die Erfahrung in unserem digitalen Atelier zu verbessern.',
    question1: 'Was hat dich heute vom Kauf abgehalten?',
    multipleAnswers: '(mehrere Antworten möglich)',
    reason1: 'Preis zu hoch für mein Budget',
    reason2: 'Teurer Versand (unter 79€)',
    reason3: 'Lieferzeiten zu lang',
    reason4: 'Verwirrende Website - finde nicht, was ich suche',
    reason5: 'Unsicherheit über die realen Abmessungen',
    reason6: 'Anderer Grund',
    reasonOtherPlaceholder: 'Du kannst den Grund angeben...',
    btnContinue: 'Weiter',
    title2: 'Was würde dir helfen, deinen Kauf heute abzuschließen?',
    intro2: 'Dein Feedback hilft uns, die Erfahrung für diejenigen zu verbessern, die authentisches italienisches Handwerk suchen.',
    suggestionPlaceholder: 'Teile mit uns, was deinen Kauf einfacher machen würde...',
    btnBack: 'Zurück',
    title3: 'Ein letzter Schritt!',
    emailIntro: 'Hinterlasse uns deine E-Mail, um personalisierte Lösungen für deine Bedürfnisse und exklusive Angebote für unsere handwerklichen Meisterwerke zu erhalten.',
    emailPlaceholder: 'Deine E-Mail',
    emailNote: 'Wir werden deine Antworten sorgfältig analysieren, um dir das beste Einkaufserlebnis zu bieten und die für dich passendste Lösung zu finden.',
    btnSubmit: 'Feedback senden',
    successTitle: 'Danke für dein wertvolles Feedback!',
    successMessage: 'Wir haben deine Antworten erhalten und werden sie sorgfältig analysieren, um unser Einkaufserlebnis zu verbessern und besser auf deine Bedürfnisse einzugehen. Italienisches Handwerk entwickelt sich auch dank deines Beitrags weiter.'
  },
  fr: {
    stepCounter: 'Étape __NUM__ de 3',
    title1: 'Attendez un moment!',
    intro1: 'Votre opinion est précieuse pour améliorer l\'expérience dans notre atelier numérique.',
    question1: 'Qu\'est-ce qui vous a empêché d\'acheter aujourd\'hui?',
    multipleAnswers: '(plusieurs réponses possibles)',
    reason1: 'Prix trop élevé pour mon budget',
    reason2: 'Livraison coûteuse (moins de 79€)',
    reason3: 'Délais de livraison trop longs',
    reason4: 'Site confus - je ne trouve pas ce que je cherche',
    reason5: 'Incertitude sur les dimensions réelles',
    reason6: 'Autre raison',
    reasonOtherPlaceholder: 'Vous pouvez préciser la raison...',
    btnContinue: 'Continuer',
    title2: 'Qu\'est-ce qui vous aiderait à finaliser votre achat aujourd\'hui?',
    intro2: 'Votre feedback nous aide à améliorer l\'expérience de ceux qui recherchent l\'authenticité de l\'artisanat italien.',
    suggestionPlaceholder: 'Partagez avec nous ce qui rendrait votre achat plus facile...',
    btnBack: 'Retour',
    title3: 'Une dernière étape!',
    emailIntro: 'Laissez-nous votre email pour recevoir des solutions personnalisées à vos besoins et des offres exclusives sur nos chefs-d\'œuvre artisanaux.',
    emailPlaceholder: 'Votre email',
    emailNote: 'Nous analyserons soigneusement vos réponses pour vous offrir la meilleure expérience d\'achat et trouver la solution la plus adaptée pour vous.',
    btnSubmit: 'Envoyer les commentaires',
    successTitle: 'Merci pour votre précieux feedback!',
    successMessage: 'Nous avons reçu vos réponses et les analyserons soigneusement pour améliorer notre expérience d\'achat et mieux répondre à vos besoins. L\'artisanat italien évolue aussi grâce à votre contribution.'
  }
};

document.addEventListener('DOMContentLoaded', function() {
  // Detect language from URL or default to Italian
  let currentLanguage = 'it';
  const path = window.location.pathname;
  
  if (path.includes('/en')) currentLanguage = 'en';
  else if (path.includes('/es')) currentLanguage = 'es';
  else if (path.includes('/de')) currentLanguage = 'de';
  else if (path.includes('/fr')) currentLanguage = 'fr';
  
  const translations = DOLFI_TRANSLATIONS[currentLanguage];
  
  // Detect if device is desktop
  function dolfiIsDesktop() {
    return window.innerWidth >= 1024 && !('ontouchstart' in window);
  }
  
  // Variables for exit intent control
  let dolfiExitIntentShown = false;
  let dolfiHasScrolledThreshold = false;
  const dolfiCookieName = 'dolfiExitIntentShown';
  const dolfiCookieDuration = 7; // Days
  let dolfiCurrentStep = 1;
  const dolfiTotalSteps = 3;
  const dolfiScrollThreshold = 35; // Scroll percentage required
  
  // Cookie management
  function dolfiGetCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
    return null;
  }
  
  function dolfiSetCookie(name, value, days) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    const expires = `expires=${date.toUTCString()}`;
    document.cookie = `${name}=${value};${expires};path=/`;
  }
  
  // DOM elements
  const dolfiOverlay = document.getElementById('dolfi-exit-intent-overlay');
  const dolfiCloseBtn = document.getElementById('dolfi-exit-intent-close');
  const dolfiForm = document.getElementById('dolfi-exit-intent-form');
  const dolfiSuccessMessage = document.getElementById('dolfi-success-message');
  const dolfiProgressBar = document.getElementById('dolfi-progress-bar');
  const dolfiSteps = document.querySelectorAll('.dolfi-step');
  const dolfiNextButtons = document.querySelectorAll('.dolfi-next-step');
  const dolfiBackButtons = document.querySelectorAll('.dolfi-back-step');
  const dolfiOtherCheckbox = document.getElementById('dolfi-other');
  const dolfiOtherReasonContainer = document.getElementById('dolfi-other-reason-container');
  
  // Update content with translations
  function updateContent() {
    // Step counters
    document.querySelectorAll('.dolfi-step-counter').forEach((el, index) => {
      el.textContent = translations.stepCounter.replace('__NUM__', index + 1);
    });
    
    // Step 1 content
    document.querySelector('#dolfi-step-1 h2').textContent = translations.title1;
    document.querySelector('#dolfi-step-1 .dolfi-exit-intent-intro').textContent = translations.intro1;
    document.querySelector('#dolfi-step-1 h3').textContent = translations.question1;
    document.querySelector('#dolfi-step-1 .dolfi-note').textContent = translations.multipleAnswers;
    
    // Reasons
    document.querySelector('label[for="dolfi-price"]').textContent = translations.reason1;
    document.querySelector('label[for="dolfi-shipping-cost"]').textContent = translations.reason2;
    document.querySelector('label[for="dolfi-delivery-time"]').textContent = translations.reason3;
    document.querySelector('label[for="dolfi-site-navigation"]').textContent = translations.reason4;
    document.querySelector('label[for="dolfi-size-uncertainty"]').textContent = translations.reason5;
    document.querySelector('label[for="dolfi-other"]').textContent = translations.reason6;
    document.querySelector('#dolfi-other-reason').placeholder = translations.reasonOtherPlaceholder;
    
    // Step 2 content
    document.querySelector('#dolfi-step-2 h2').textContent = translations.title2;
    document.querySelector('#dolfi-step-2 .dolfi-exit-intent-intro').textContent = translations.intro2;
    document.querySelector('#dolfi-suggestion').placeholder = translations.suggestionPlaceholder;
    
    // Step 3 content
    document.querySelector('#dolfi-step-3 h2').textContent = translations.title3;
    document.querySelector('.dolfi-email-intro').textContent = translations.emailIntro;
    document.querySelector('#dolfi-email').placeholder = translations.emailPlaceholder;
    document.querySelector('.dolfi-email-note').textContent = translations.emailNote;
    
    // Buttons
    document.querySelectorAll('.dolfi-next-step').forEach(btn => {
      btn.textContent = translations.btnContinue;
    });
    document.querySelectorAll('.dolfi-back-step').forEach(btn => {
      btn.textContent = translations.btnBack;
    });
    document.querySelector('#dolfi-submit-feedback').textContent = translations.btnSubmit;
    
    // Success message
    document.querySelector('#dolfi-success-message h2').textContent = translations.successTitle;
    document.querySelector('#dolfi-success-message p').textContent = translations.successMessage;
  }
  
  // Initialize content with current language
  if (dolfiOverlay) {
    updateContent();
    
    // Toggle for "Other" field
    if (dolfiOtherCheckbox) {
      dolfiOtherCheckbox.addEventListener('change', function() {
        dolfiOtherReasonContainer.style.display = this.checked ? 'block' : 'none';
      });
    }
    
    // Update progress bar
    function dolfiUpdateProgressBar() {
      const progressPercentage = (dolfiCurrentStep / dolfiTotalSteps) * 100;
      dolfiProgressBar.style.width = `${progressPercentage}%`;
    }
    
    // Show exit intent (only on desktop)
    function dolfiShowExitIntent() {
      if (!dolfiIsDesktop()) {
        return; // Don't show popup on mobile/tablet
      }
      
      if (!dolfiExitIntentShown && !dolfiGetCookie(dolfiCookieName) && !dolfiIsCheckoutPage() && dolfiHasScrolledThreshold) {
        // Block background scroll
        document.body.classList.add('dolfi-popup-open');
        
        dolfiOverlay.style.display = 'flex';
        dolfiExitIntentShown = true;
        dolfiSetCookie(dolfiCookieName, 'true', dolfiCookieDuration);
        
        // Initialize view
        dolfiCurrentStep = 1;
        dolfiUpdateProgressBar();
      }
    }
    
    // Calculate scroll percentage
    function dolfiCalculateScrollPercentage() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const windowHeight = window.innerHeight;
      const documentHeight = Math.max(
        document.body.scrollHeight, 
        document.body.offsetHeight, 
        document.documentElement.clientHeight, 
        document.documentElement.scrollHeight, 
        document.documentElement.offsetHeight
      );
      
      const scrollPercentage = (scrollTop / (documentHeight - windowHeight)) * 100;
      
      if (scrollPercentage >= dolfiScrollThreshold && !dolfiHasScrolledThreshold) {
        dolfiHasScrolledThreshold = true;
      }
      
      return scrollPercentage;
    }
    
    // Show specific step
    function dolfiShowStep(stepNumber) {
      dolfiSteps.forEach(step => {
        step.style.display = 'none';
      });
      const targetStep = document.getElementById(`dolfi-step-${stepNumber}`);
      if (targetStep) {
        targetStep.style.display = 'block';
        dolfiCurrentStep = stepNumber;
        dolfiUpdateProgressBar();
        
        // Manage required fields based on current step
        const suggestionField = document.getElementById('dolfi-suggestion');
        const emailField = document.getElementById('dolfi-email');
        
        if (suggestionField) {
          suggestionField.required = (stepNumber >= 2);
        }
        if (emailField) {
          emailField.required = (stepNumber >= 3);
        }
      }
    }
    
    // Next buttons
    dolfiNextButtons.forEach(button => {
      button.addEventListener('click', function() {
        const parentStep = this.closest('.dolfi-step');
        const currentStepNumber = parseInt(parentStep.getAttribute('data-step'));
        const nextStepNumber = currentStepNumber + 1;
        
        if (nextStepNumber <= dolfiTotalSteps) {
          dolfiShowStep(nextStepNumber);
        }
      });
    });
    
    // Back buttons
    dolfiBackButtons.forEach(button => {
      button.addEventListener('click', function() {
        const parentStep = this.closest('.dolfi-step');
        const currentStepNumber = parseInt(parentStep.getAttribute('data-step'));
        const prevStepNumber = currentStepNumber - 1;
        
        if (prevStepNumber >= 1) {
          dolfiShowStep(prevStepNumber);
        }
      });
    });
    
    // Don't show popup on checkout pages
    function dolfiIsCheckoutPage() {
      return window.location.href.indexOf('/checkout') !== -1 || 
             window.location.href.indexOf('/cart') !== -1;
    }
    
    // Monitor user scroll
    document.addEventListener('scroll', function() {
      dolfiCalculateScrollPercentage();
    });
    
    // Mouse leaves top of page (exit intent)
    document.addEventListener('mouseout', function(e) {
      if (e.clientY < 50 && !e.relatedTarget && !dolfiExitIntentShown) {
        dolfiShowExitIntent();
      }
    });
    
    // Close popup (only via X button)
    dolfiCloseBtn.addEventListener('click', function() {
      document.body.classList.remove('dolfi-popup-open');
      dolfiOverlay.style.display = 'none';
    });
    
    // Note: Removed click-outside-to-close functionality for better UX
    
    // Submit form
    dolfiForm.addEventListener('submit', function(e) {
      e.preventDefault();
      
      // Disable submit button to prevent multiple submissions
      const submitBtn = document.getElementById('dolfi-submit-feedback');
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = 'Invio in corso...';
      }
      
      // Collect form data
      const reasonsChecked = Array.from(dolfiForm.querySelectorAll('input[name="reason"]:checked'))
        .map(checkbox => checkbox.value);
      
      // Handle "Other" option
      let otherReasonText = "";
      if (dolfiOtherCheckbox && dolfiOtherCheckbox.checked) {
        const otherTextarea = document.getElementById('dolfi-other-reason');
        if (otherTextarea) {
          otherReasonText = otherTextarea.value;
        }
      }
      
      const suggestionTextarea = dolfiForm.querySelector('#dolfi-suggestion');
      const emailInput = dolfiForm.querySelector('#dolfi-email');
      
      const formData = {
        brand: 'Dolfi Artigianato',
        language: currentLanguage,
        
        // Step 1: Ragioni di abbandono
        abandonment_reasons: reasonsChecked.length > 0 ? reasonsChecked : ["Not specified"],
        abandonment_other_reason: otherReasonText,
        
        // Step 2: Suggerimenti per migliorare
        improvement_suggestion: suggestionTextarea ? suggestionTextarea.value : '',
        
        // Step 3: Contatto
        customer_email: emailInput ? emailInput.value : '',
        
        // Dati tecnici
        page_url: window.location.href,
        timestamp: new Date().toISOString(),
        user_agent: navigator.userAgent,
        referrer: document.referrer
      };
      
      console.log('Dolfi Exit Intent - Sending data:', formData);
      
      // Send data to webhook
      fetch('https://hook.eu2.make.com/rbzsnt7d26kkxqnf8tzb6whwciy7bibh', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData)
      })
      .then(response => {
        console.log('Dolfi Exit Intent - Response status:', response.status);
        return response.json().catch(() => ({ success: response.ok }));
      })
      .then(data => {
        console.log('Dolfi Exit Intent - Response data:', data);
        
        // Show success message
        dolfiForm.style.display = 'none';
        dolfiSuccessMessage.style.display = 'block';
        
        // Update progress bar to 100%
        dolfiProgressBar.style.width = '100%';
        
        // Close popup after some seconds
        setTimeout(function() {
          document.body.classList.remove('dolfi-popup-open');
          dolfiOverlay.style.display = 'none';
        }, 6000);
      })
      .catch(error => {
        console.error('Dolfi Exit Intent - Error:', error);
        
        // Show success message anyway for UX
        dolfiForm.style.display = 'none';
        dolfiSuccessMessage.style.display = 'block';
        dolfiProgressBar.style.width = '100%';
        
        setTimeout(function() {
          document.body.classList.remove('dolfi-popup-open');
          dolfiOverlay.style.display = 'none';
        }, 6000);
      })
      .finally(() => {
        // Re-enable submit button
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.textContent = translations.btnSubmit;
        }
      });
    });
    
    // Make checkbox items fully clickable
    const dolfiCheckboxItems = document.querySelectorAll('.dolfi-checkbox-item');
    dolfiCheckboxItems.forEach(item => {
      item.addEventListener('click', function(e) {
        // Prevent default behavior for labels
        e.preventDefault();
        
        const checkbox = this.querySelector('input[type="checkbox"]');
        if (checkbox) {
          // Toggle checkbox state
          checkbox.checked = !checkbox.checked;
          
          // Handle "Other" checkbox toggle
          if (checkbox.id === 'dolfi-other') {
            dolfiOtherReasonContainer.style.display = checkbox.checked ? 'block' : 'none';
          }
          
          // Trigger change event for any other listeners
          checkbox.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
      
      // Prevent label from interfering with our custom click handler
      const label = item.querySelector('label');
      if (label) {
        label.addEventListener('click', function(e) {
          e.preventDefault();
        });
      }
    });
    
    // Initialize display
    dolfiUpdateProgressBar();
  }
});